import React from 'react';
import { motion } from 'motion/react';
import { User } from 'lucide-react';
import { Reveal } from './Tech';

/**
 * SplitProfile — larger-than-life portrait on one half, information on the other,
 * separated by a glowing diagonal edge. Mouse movement adds parallax depth.
 */
export const SplitProfile = ({
  image, imagePosition, fit = 'cover', name, role, bio, caption, captionIcon: CaptionIcon = User,
  brand, meta = [], actions, reverse = false, accent = 'cyan', index, compact = false
}) => {
  const onMove = (e) => {
    const el = e.currentTarget;
    const r = el.getBoundingClientRect();
    el.style.setProperty('--px', ((e.clientX - r.left) / r.width - 0.5).toFixed(3));
    el.style.setProperty('--py', ((e.clientY - r.top) / r.height - 0.5).toFixed(3));
  };
  const onLeave = (e) => { e.currentTarget.style.setProperty('--px', 0); e.currentTarget.style.setProperty('--py', 0); };

  return (
    <Reveal y={32} className={`split split-accent-${accent} ${reverse ? 'reverse' : ''} ${compact ? 'compact' : ''}`} onMouseMove={onMove} onMouseLeave={onLeave}>
      <div className="split-media">
        <div className="split-backdrop" style={{ backgroundImage: `url(${image})` }} />
        <motion.img
          src={image}
          alt={name}
          className={`split-img ${fit === 'contain' ? 'contain' : ''}`}
          style={{ objectPosition: imagePosition || 'center 20%' }}
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
        />
        {caption && (
          <span className="split-caption"><CaptionIcon className="w-3.5 h-3.5" style={{ color: 'var(--split-accent)' }} />{caption}</span>
        )}
        {brand && (
          <span className="split-brand brand-mark" style={{ width: 56, height: 56, background: brand.bg || '#fff' }}>
            <img src={brand.src} alt={brand.alt} />
          </span>
        )}
      </div>
      <div className="split-edge" aria-hidden="true" />
      <div className="split-info">
        <span className="split-index">{index}</span>
        <h3 className="split-name">{name}</h3>
        <p className="split-role">{role}</p>
        <p className="split-bio">{bio}</p>
        {meta.length > 0 && (
          <div className="split-meta">
            {meta.map((m) => <span key={m} className="people-chip rounded-full px-3 py-1 text-xs">{m}</span>)}
          </div>
        )}
        {actions && <div className="split-actions">{actions}</div>}
      </div>
    </Reveal>
  );
};
